import {
  CHECKOUT_PAYMENT_RESET,
  CHECKOUT_PAYMENT_REQUEST,
  CHECKOUT_PAYMENT_SUCCESS,
  CHECKOUT_PAYMENT_FAILURE,
  CHECKOUT_PAYMENT_HAS_ACCOUNT,
  CHECKOUT_PAYMENT_SET_FETCH,
  CHECKOUT_PAYMENT_ALREADY_BOOKED,
  CHECKOUT_PAYMENT_FREE_FAILURE,
  CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS,
  CHECKOUT_PAYMENT_USE_CREDITS,
  CHECKOUT_PAYMENT_NOT_USE_CREDITS,
} from '../types';

const initialState = {
  status: 'initial',
  error: '',
  membershipError: '',
  usingCredits: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT_PAYMENT_RESET:
      return {
        ...state,
        status: 'initial',
        membershipError: '',
      };
    case CHECKOUT_PAYMENT_ALREADY_BOOKED:
      return {
        ...state,
        status: 'alreadyBooked',
      };
    case CHECKOUT_PAYMENT_REQUEST:
    case CHECKOUT_PAYMENT_SET_FETCH:
      return {
        ...state,
        status: 'fetching',
      };
    case CHECKOUT_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'success',
        membershipError: '',
      };
    case CHECKOUT_PAYMENT_FAILURE:
      return {
        ...state,
        status: 'failure',
        error: action.payload,
      };
    case CHECKOUT_PAYMENT_FREE_FAILURE:
      return {
        ...state,
        membershipError: action.payload,
      };
    case CHECKOUT_PAYMENT_HAS_ACCOUNT:
      return {
        ...state,
        status: 'hasAccount',
      };
    case CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS:
      return {
        ...state,
        usingCredits: !state.usingCredits,
      };
    case CHECKOUT_PAYMENT_USE_CREDITS:
      return {
        ...state,
        usingCredits: true,
      };
    case CHECKOUT_PAYMENT_NOT_USE_CREDITS:
      return {
        ...state,
        usingCredits: false,
      };
    default:
      return state;
  }
}
